var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap-video"},[_c('vueVideoPlayer',{attrs:{"src":_vm.moduleDataSource.src,"cover_url":_vm.moduleDataSource.img}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }